import React, { Fragment } from "react";

import "./Card.css";

const Card = (props) => (
  <Fragment>
    <div className="mn-grid__row">
      <div className="mn-grid__col">
        <div className="mn-card">{props.children}</div>
      </div>
    </div>
  </Fragment>
);

export default Card;
